import { IActivityAction } from '@models/actions/IBaseAction';
import { createActivityModalExecutor } from '@organisms/actions/createActivityModalExecutor';
import { getActivityIdFromCompositeId } from '@utils/helpers';
import { IRequestAddApprovalProps } from './IRequestAddApprovalProps';
import { RequestAddApprovalModal } from './RequestAddApprovalModal';

export const RequestAddApprovalExecutor = createActivityModalExecutor<IRequestAddApprovalProps>({
    modal: RequestAddApprovalModal,
    defaultModalSize: 'l',
    mapProps: ({ objId, action, okButtonText, cancelButtonText, modalSize, completeHandler }) => ({
        activityId: getActivityIdFromCompositeId(objId),
        docId: (action as IActivityAction)?.docId ?? '-1',
        actionKey: action.key,
        okButtonText,
        cancelButtonText,
        modalSize,
        completeHandler,
    }),
});
